var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #63666f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4076",
    "data-name": "Group 4076",
    transform: "translate(6105 9095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1135",
    "data-name": "Rectangle 1135",
    className: "cls-1",
    width: 22,
    height: 22,
    transform: "translate(-6105 -9095)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3572",
    "data-name": "Group 3572",
    transform: "translate(-6105 -9092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6915",
    "data-name": "Path 6915",
    className: "cls-2",
    d: "M14.792,13.666,8.485,7.433l4.28-4.2,2.027,2.027L19.3.751A1.453,1.453,0,0,0,18.02,0H1.5A1.506,1.506,0,0,0,0,1.5V13.515a1.506,1.506,0,0,0,1.5,1.5H18.02a1.506,1.506,0,0,0,1.5-1.5V9.01ZM3,3H8.485a.709.709,0,0,1,.751.751.709.709,0,0,1-.751.751H3a.709.709,0,0,1-.751-.751A.709.709,0,0,1,3,3ZM3,6.758H6.232a.709.709,0,0,1,.751.751.709.709,0,0,1-.751.751H3a.709.709,0,0,1-.751-.751A.709.709,0,0,1,3,6.758Zm5.481,5.256H3a.751.751,0,1,1,0-1.5H8.485a.709.709,0,0,1,.751.751A.752.752,0,0,1,8.485,12.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6916",
    "data-name": "Path 6916",
    className: "cls-2",
    d: "M24.811,3,18.579,9.157,16.551,7.13,15.5,8.181l2.027,2.027h0l1.051,1.051,7.283-7.208Z",
    transform: "translate(-3.862 -0.747)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCue);
export default __webpack_public_path__ + "static/media/cue.0ad64e35ede82d6827230b2a55e7d1ef.svg";
export { ForwardRef as ReactComponent };